import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-sliding-tabs',
  templateUrl: './sliding-tabs.component.html',
  styleUrls: ['./sliding-tabs.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SlidingTabsComponent),
      multi: true
    }
  ]
})
export class SlidingTabsComponent implements OnInit {

  @Input() items: any[];
  @Input() name: string;
  @Input() selected: any;
  
  @Output() selectedChange = new EventEmitter();

  value: any = null

  sliderWidth: string
  sliderPosition: string

  offsetPixel = 4

  constructor() { }

  ngOnInit(): void {
    this.value = this.selected

    let margin = this.offsetPixel * (this.items.length + 1)
    this.sliderWidth = `calc((100% - ${margin}px) /  ${this.items.length})`

    const selectedIndex = this.items.map(o => o.value).indexOf(this.selected)
    this.sliderPosition = this.positionSlider(selectedIndex)
  }

  modelChange(e, i: number): void {
    this.sliderPosition = this.positionSlider(i)
    this.selectedChange.emit(e);
  }

  positionSlider(index: number): string {
    if (index < 0) {
      index = 0
    }
    let margin = this.offsetPixel * (this.items.length + 1)
    return `calc( ((100% - ${margin}px) / ${this.items.length} + ${this.offsetPixel}px) * ${index} )`
  }
}
